import {Component, forwardRef, Input, OnInit, Optional, Self} from '@angular/core';
import {ControlValueAccessor,  NgControl} from "@angular/forms";

@Component({
  selector: 'carbon-textarea',
  templateUrl: './carbon-textarea.component.html',
  styleUrls: ['./carbon-textarea.component.css'],
})
export class CarbonTextareaComponent implements OnInit, ControlValueAccessor {

  @Input() id: string;
  @Input() label: string;
  @Input() showLabel: boolean = true;
  @Input() require: boolean;
  @Input() readonly: boolean;
  @Input() dados: string = null;

  caracteresDisponiveis = 5000;
  value = '';
  disabled = false;

  private onChange = (value: any) => {
  };
  private onTouched = () => {
  };

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
  }

  setCaracteresRestante(caracteres: string) {
    this.caracteresDisponiveis = 5000 - caracteres.length;
  }

  get control() {
    return this.ngControl ? this.ngControl.control : null;
  }

  get isInvalid(): boolean {
    return !!this.control && this.control.invalid && (this.control.dirty || this.control.touched);
  }

  get isValid(): boolean {
    return !!this.control && this.control.valid && this.control.value !== '' && (this.control.dirty || this.control.touched);
  }

  get errorMessage(): string {
    if (!this.control || !this.control.errors) return '';

    if (this.control.errors['required']) return 'Campo obrigatório';
    if (this.control.errors['minlength']) return 'Texto muito curto';
    if (this.control.errors['maxlength']) return 'Texto muito longo';

    return 'Valor inválido';
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.value = value;
    this.onChange(value);
  }

  onBlur() {
    this.onTouched();
  }
}
